import { MIME_MICROSOFT, MIME_PREFIX_RAW } from '../constants/mimes';

export const isMicrosoftDocument = (mimeType) => MIME_MICROSOFT.some((i) => i === mimeType);

export const isRawPrefix = (prefix) => {
    let isRaw = false;

    MIME_PREFIX_RAW.forEach((mimePrefix) => {
        if (isRaw) return;

        if (prefix.startsWith(mimePrefix)) {
            isRaw = true;
        }
    });

    return isRaw;
};

export const formatBytes = (bytes: number, decimals: number = 2) => {
    if (bytes === 0) return '0 Bytes';

    const k = 1024; // Define the size of a kilobyte
    const dm = decimals < 0 ? 0 : decimals; // Number of decimals to include
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};
